import { render, staticRenderFns } from "./VaInputWrapper.vue?vue&type=template&id=110064a2&"
import script from "./VaInputWrapper.vue?vue&type=script&lang=js&"
export * from "./VaInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./VaInputWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports